'use client';
import React from 'react';
import { StockSymbol } from '@benzinga/session';
import { noop } from '@benzinga/utils';

interface Props {
  onClose: () => void;
  setDialogMode: (dialog: boolean) => void;
  updateHeight: () => void;
  symbol: StockSymbol;
}

export const TickerContext = React.createContext<Props>({
  onClose: noop,
  setDialogMode: noop,
  symbol: 'AAPL',
  updateHeight: noop,
});

export const TickerContextProvider: React.FC<React.PropsWithChildren<Props>> = props => {
  return (
    <TickerContext.Provider
      value={{
        onClose: props.onClose ?? noop,
        setDialogMode: props.setDialogMode ?? noop,
        symbol: props.symbol ?? 'AAPl',
        updateHeight: props.updateHeight ?? noop,
      }}
    >
      {props.children}
    </TickerContext.Provider>
  );
};
